<template>
    <div>
        <b-modal v-model="errorboleta" centered size="lg">
            <div>       
                <b-row no-gutters>
                <b-col md="5" class="ml-4">
                    <b-img src="images/error3.png"  height="260%" style="width:90%" ></b-img>
                </b-col>
                <b-col md="6">
                    <b-card-body title="Ups! error">
                        <b-card-text>
                            {{error1}} <br>
                            <hr>
                            {{error2}}<template v-if="errorJson && errorJson.response.code == '2012'">, consulte vía WhatsApp si tiene deuda pendiente: <b>995570648</b>, <b>920822008</b>.</template><br> 
                            <hr>
                            {{error3}} <br>
                        </b-card-text>
                    </b-card-body>
                </b-col>
                </b-row>
            </div>
            <template slot="modal-footer">
                <b-button variant="danger" @click="cerrarmodal()" >Cerrar</b-button>
            </template>
        </b-modal>
    </div>
</template><script>
export default {
    props:['errormodal','error1','error2','error3','errorJson'],
    name:'Errormsj',
    data() {
        return {
            errorboleta:false
        }
    },
    mounted() {
       this.init()
    },
    methods: {
        init(){
            this.errorboleta = this.errormodal
        },
        cerrarmodal(){
            this.errorboleta = false;
            this.$emit("cerrarmodal", this.errorboleta);
        },
    },
}
</script>
<style scoped>
    
</style>